'use client'
import { useEffect, useState } from 'react'
import SecNav from 'components/privat/SecNav'
import {
  useMainContext,
  CaptainContext,
  usePrivateContext
} from 'utils/context'
import { getRequest } from 'services/private'
import PopoverButton from 'components/PopoverButton'
import { UserGroupIcon, StarIcon } from '@heroicons/react/24/outline'
import { useRouter } from 'next/navigation'
import SubTitle from 'components/privat/SubTitle'

const secNav = [
  {
    id: 'league',
    name: 'Lliga',
    link: '/privat/federat/area-capita/lligues/lliga'
  },
  {
    id: 'management',
    name: 'Gestió d’equip',
    link: '/privat/federat/area-capita/lligues/gestio-dequip'
  },
  {
    id: 'lineups',
    name: 'Alineacions i Actes',
    link: '/privat/federat/area-capita/lligues/alineacions-i-actes'
  },
  {
    id: 'changeData',
    name: 'Canvi data',
    link: '/privat/federat/area-capita/lligues/canvi-data'
  },
  {
    name: 'Canvi seu',
    link: '/privat/federat/area-capita/lligues/canvi-seu'
  }
]

const Layout = ({ children }) => {
  const router = useRouter()
  const { fedId, fedToken } = useMainContext()
  const { fedDetails } = usePrivateContext() || {}
  const [teamFilter, setTeamFilter] = useState()
  const [teamFilterSelected, setTeamFilterSelected] = useState()
  const [teamSelectedData, setTeamSelectedData] = useState({})
  const [teamData, setTeamData] = useState()
  // const [dayFilterSelected, setDayFilterSelected] = useState('')
  // const [dayFilter, setDayFilter] = useState([])
  const [showFiltersList, setShowFiltersList] = useState(['main', 'secondary'])
  const [captainBlocked, setCaptainBlocked] = useState(0)

  const setupFilters = async () => {
    const teamsReq = await getRequest({
      user: fedId,
      token: fedToken,
      endpoint: 'LEAGUES_TEAM_CAPTAIN'
    })
    setTeamFilter(
      teamsReq.Teams.map((team) => ({
        text: team.NameGroup,
        id: team.IdTeam
      }))
    )
    const selectedTeam = teamsReq.Teams[0]
    setTeamFilterSelected(selectedTeam)
    setTeamSelectedData(selectedTeam)
    setTeamData(teamsReq.Teams)
    setCaptainBlocked(teamsReq.CaptainBlocked)
  }

  useEffect(() => {
    setupFilters()
  }, [])

  useEffect(() => {
    if (
      Object.keys(fedDetails || {}).length &&
      !fedDetails?.PersonalInformation?.SupportsCaptain
    ) {
      router.push('/privat/federat/dades-personals')
    }
  }, [fedDetails])

  return (
    <CaptainContext.Provider
      value={{
        teamFilterSelected,
        showFiltersList,
        setShowFiltersList,
        teamFilterSelected,
        teamData,
        teamSelectedData
      }}
    >
      <SecNav items={secNav} bg="sec-grey-4" />
      <div className="mb-44">
        <div className="bg-blue lg:pl-10 px-4">
          <div className="max-w-6xl flex items-center flex-row">
            <div className="flex h-10 w-10 lg:h-16 lg:w-16 items-center justify-center rounded-full bg-white">
              <StarIcon className="h-5 w-5 lg:h-10 lg:w-10" />
            </div>
            {/* <img
              src={'/assets/images/players/no-photo.svg'}
              className="object-cover w-full h-full"
            /> */}
            <p className="text-white text-small lg:text-[33px] ml-8 lg:mt-0">
              {teamFilterSelected?.NameGroup || teamFilterSelected?.text}
            </p>
            {teamFilter && (
              <div className="ml-auto my-3">
                <PopoverButton
                  text="Canviar equip"
                  removesTextMobile
                  iconComponent={<UserGroupIcon />}
                  options={teamFilter}
                  onChangeAction={(e) => {
                    setTeamFilterSelected(
                      teamData.find(
                        ({ IdTeam }) => `${IdTeam}` === e.target.dataset.id
                      )
                    )
                  }}
                  className="lg:py-3"
                />
              </div>
            )}
          </div>
        </div>
        {!captainBlocked ? (
          children
        ) : (
          <div className="max-w-6xl mx-3 lg:mx-10 py-10">
            <SubTitle>Llicència pendent de pagament</SubTitle>
          </div>
        )}
      </div>
    </CaptainContext.Provider>
  )
}

export default Layout
